var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-sheet pb-4"},[_c('div',{staticClass:"bottom-sheet-content"},[_c('DataAnnotations',{attrs:{"fullscreenprop":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }